import {
  InfoCircleOutlined,
  UsergroupAddOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Modal, Space, Table, Tag, Popover } from "antd";
import { createContext } from "react";
import { useMutation } from "react-query";
import { deleteRole } from "../../api/roles";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router";
import EditButton from "../UI/EditButton/editbutton";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import ViewButton from "../UI/ViewButton/viewbutton";
import { useTranslation } from "react-i18next";

type PropsType = {
  data: [];
  refetchRoles: () => {};
  handleEditRoleModal: (roleId: any) => void;
  handleGetUsersForRole: (roleId: any) => void;
  handleGetAllUsers: (roleId: any) => void;
  isRolesLoading: boolean;
  tableKey: number;
};

interface RolesInterface {
  id: number;
  name: string;
  description: string;
}
const RolesList = ({
  data: role,
  refetchRoles,
  handleEditRoleModal,
  handleGetUsersForRole,
  handleGetAllUsers,
  isRolesLoading,
  tableKey,
}: PropsType) => {
  const { mutateAsync: deleteRoleMutation } = useMutation(
    "deleteRole",
    (id: any) => deleteRole(id)
  );
  const navigate = useNavigate();
  const [t] = useTranslation("common");

  // const [open, setOpen] = useState(false);
  // const [idToDelete, setIdToDelete] = useState<string | undefined>(undefined);
  // const [nameToDelete, setNameToDelete] = useState<any>();
  // const DeleteModal = (
  //   id: string | undefined,
  //   name: string
  // ): void => {
  //   setOpen(true);
  //   setIdToDelete(id);
  //   setNameToDelete(name);
  // };

  // const handleOk = () => {
  //   deleteRoleMutation(idToDelete).then(() => {
  //     refetchRoles();
  //   });
  //   setOpen(false);
  // };
  const ReachableContext = createContext<string | null>(null);
  function DeleteModal(id: string | undefined, name: string) {
    Modal.confirm({
      centered: true,
      content: (
        <>
          <ReachableContext.Consumer>
            {() => (
              <div>
                {t("are-you-sure-you-want-to-delete")}{" "}
                <span style={{ color: "#1677FF", fontWeight: "bold" }}>
                  {name}
                </span>
                ?
              </div>
            )}
          </ReachableContext.Consumer>
        </>
      ),
      okText: `${t("confirm")}`,
      cancelText: `${t("cancel")}`,
      onOk: () => {
        deleteRoleMutation(id).then(() => {
          refetchRoles();
        });
      },
      onCancel: () => {},
      icon: <WarningOutlined style={{ color: "red" }} />,
    });
  }
  const content = <div>{t("information")}</div>;
  const user = <div>{t("add-users-to-role")}</div>;

  const columns: ColumnsType<RolesInterface> = [
    {
      title: `${t("role")}`,
      dataIndex: "name",
      key: "name",
      className: "table-header",
    },
    {
      title: `${t("status")}`,
      dataIndex: "isActive",
      align: "center",
      key: "isActive",
      width: "3rem",
      render: (record: any) =>
        record ? (
          <Tag className="active">Active</Tag>
        ) : (
          <Tag className="inactive">Inactive</Tag>
        ),
    },
    {
      title: `${t("action")}`,
      width: "6rem",
      align: "center",
      fixed: "right",
      render: (record: any) => {
        return (
          <Space>
            <ViewButton onClick={() => handleGetUsersForRole(record?.id)} />
            <Popover content={user} mouseEnterDelay={0} mouseLeaveDelay={0}>
              <UsergroupAddOutlined
                style={{
                  color: "#212121",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onClick={() => {
                  handleGetAllUsers(record?.id);
                }}
              />
            </Popover>
            <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
              <InfoCircleOutlined
                style={{
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#212121",
                }}
                onClick={() =>
                  navigate(`/permissions`, {
                    state: {
                      roleId: record.id,
                    },
                  })
                }
              />
            </Popover>
            <EditButton
              onClick={() => {
                handleEditRoleModal(record?.id);
              }}
            />
            <DeleteButton
              onClick={() => {
                DeleteModal(record?.id, record?.name);
              }}
            />
          </Space>
        );
      },
    },
  ];
  return (
    <>
      {/* <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      /> */}
      <Table
        dataSource={role}
        key={tableKey}
        columns={columns}
        loading={isRolesLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
        pagination={{ pageSize: 10 }}
      />
    </>
  );
};

export default RolesList;
